import React from 'react';

const CheckIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check">
        <path
          id="Vector"
          d="M18.4346 5.54834C19.0229 5.06819 19.8898 5.10223 20.4385 5.65088L20.541 5.76514C20.9891 6.31431 20.9892 7.10563 20.541 7.65479L20.4385 7.76807L9.8584 18.3481C9.30971 18.8968 8.44287 18.9318 7.85449 18.4517L7.74121 18.3481L3.56055 14.1685C2.97558 13.5832 2.97556 12.6365 3.56055 12.0513L3.6748 11.9487C4.2631 11.4686 5.129 11.5028 5.67773 12.0513L8.79492 15.1675L18.3213 5.65088L18.4346 5.54834Z"
          fill="#5BC4BF"
          stroke="#5BC4BF"
        />
      </g>
    </svg>
  );
};

export default CheckIcon;
